import(/* webpackMode: "eager", webpackExports: ["SharedOrderPageClient"] */ "/vercel/path0/src/app/[code]/components/SharedOrderPageClient.tsx");
